import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ComparisonOperator } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from 'src/app/pages/shared/base/components/base-form-page.component';
import { OutboxMessageAdvancedSearchRequest } from './../../../../../core/api/models/outbox-message-advanced-search-request';

@Component({
  selector: 'outbox-advanced-search-form.component',
  templateUrl: './outbox-advanced-search-form.component.html',
  styles: [
    `
      .dialog-content {
        // min-width: 400px;
        max-width: 1200px;
      }
      .menu-item:not(:last-child) {
        border-bottom: 1px solid #e7e7e7;
      }
    `,
  ],
  standalone: false,
})
export class OutboxAdvancedSearchFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: OutboxMessageAdvancedSearchRequest = {};
  get ComparisonOperator() {
    return ComparisonOperator;
  }
  isDisabledSubmitBtn: boolean = false;
  //#endregion

  constructor(
    private dialogRef: MatDialogRef<OutboxAdvancedSearchFormComponent>,
    @Inject(MAT_DIALOG_DATA) public filterData: any
  ) {
    super();
  }

  //#region init model
  ngOnInit() {
    try {
      if (Object.keys(this.filterData.filterData).length != 0)
        this.formPageConfig.isEditMode = true;

      super.ngOnInit();
      this.fields = 'pages.outboxMessages.advancedSearch.';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  initModel(): void {
    try {
      if (this.formPageConfig.isEditMode)
        this.model = Object.assign({}, this.filterData.filterData.body);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  initForm() {}
  //#endregion

  onSubmit() {
    try {
      this.unSubs();

      if (this.model.guild?.guildName) {
        this.model.guild.operator = this.model.guild.operator
          ? this.model.guild.operator
          : ComparisonOperator.Contains;
        this.model.guild.guildName = this.model.guild.guildName.trim();
      }
      if (this.model.toNumber?.toNumber) {
        this.model.toNumber.operator = this.model.toNumber.operator
          ? this.model.toNumber.operator
          : ComparisonOperator.EqualTo;
        this.model.toNumber.toNumber = this.model.toNumber.toNumber.trim();
      } else delete this.model.toNumber;

      if (this.model.zipCode?.zipCode) {
        this.model.zipCode.operator = this.model.zipCode.operator
          ? this.model.zipCode.operator
          : ComparisonOperator.Contains;
        this.model.zipCode.zipCode = this.model.zipCode.zipCode;
      }
      if (this.model.zone?.zoneName) {
        this.model.zone.operator = this.model.zone.operator
          ? this.model.zone.operator
          : ComparisonOperator.Contains;
        this.model.zone.zoneName = this.model.zone.zoneName.trim();
      }
      if (
        this.model.deliveryStatus?.deliveryStatus ||
        this.model.deliveryStatus?.deliveryStatus == 0
      ) {
        this.model.deliveryStatus.operator = this.model.deliveryStatus.operator
          ? this.model.deliveryStatus.operator
          : ComparisonOperator.EqualTo;
        this.model.deliveryStatus.deliveryStatus =
          this.model.deliveryStatus.deliveryStatus;
      } else delete this.model.deliveryStatus;

      if (
        this.model.sendStatus?.sendStatus ||
        this.model.sendStatus?.sendStatus == 0
      ) {
        this.model.sendStatus.operator = this.model.sendStatus.operator
          ? this.model.sendStatus.operator
          : ComparisonOperator.EqualTo;
        this.model.sendStatus.sendStatus = this.model.sendStatus.sendStatus;
      } else delete this.model.sendStatus;

      if (this.model.description?.description) {
        this.model.description.operator = this.model.description.operator
          ? this.model.description.operator
          : ComparisonOperator.Contains;
        this.model.description.description =
          this.model.description.description.trim();
      }
      if (this.model.smsText?.smsText) {
        this.model.smsText.operator = this.model.smsText.operator
          ? this.model.smsText.operator
          : ComparisonOperator.Contains;
        this.model.smsText.smsText = this.model.smsText.smsText.trim();
      } else delete this.model.smsText;

      if (this.model.startDate) this.model.startDate = this.model.startDate;
      if (this.model.endDate) this.model.endDate = this.model.endDate;

      if (this.model.phonebookIds && this.model.phonebookIds.length == 0) {
        this.model.phonebookIds = undefined;
      }
      this.dialogRef.close({ filter: this.model });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  //when value changes
  setValue(value, objectName, fieldName) {
    try {
      this.model[objectName] = {};
      if (
        value ||
        ((objectName == 'sendStatus' || objectName == 'deliveryStatus') &&
          value == 0)
      ) {
        if (fieldName) this.model[objectName][fieldName] = value;
        else this.model[objectName] = value;
      }
      this.checkModelValues();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smsReport);
    }
  }

  checkModelValues() {
    if (
      (this.model.sendStatus?.sendStatus ||
        this.model.deliveryStatus?.deliveryStatus ||
        this.model.smsText?.smsText ||
        this.model.toNumber?.toNumber) &&
      (!this.model.startDate || !this.model.endDate)
    ) {
      this.isDisabledSubmitBtn = true;
    } else this.isDisabledSubmitBtn = false;
  }

  onClose() {
    this.unSubs();
    this.dialogRef.close(false);
  }
}
